import React, { useCallback, useEffect, useRef, useState } from 'react';
import useWindowWidth from './useWindowWidth';

const useTableHeightAdjustment = (minElements = 5) => {
  const [height, setHeight] = useState(0);
  const windowSize = useWindowWidth();
  const ref = useRef([]);

  const getElements = useCallback(
    elements =>
      React.Children.map(elements, (e, i) => {
        if (i >= minElements) return e;
        return React.cloneElement(e, { ref: r => (ref.current[i] = r) });
      }),
    [minElements]
  );

  useEffect(() => {
    const elements = ref.current;
    if (elements.length) {
      setHeight(elements.reduce((a, b) => a + b?.offsetHeight ?? 0, 0));
    }
  }, [ref.current.length, windowSize]);

  return [height, getElements];
};

export default useTableHeightAdjustment;
